/*
* <license header>
*/

import React from 'react'
import { Heading, Text, View } from '@adobe/react-spectrum'
import Star from '@spectrum-icons/workflow/Star'
import StarOutline from '@spectrum-icons/workflow/StarOutline'

const STATUS_CONFIG = {
  green: { label: 'Deployed', color: '#4caf50' },
  yellow: { label: 'Draft', color: '#ffc107' },
  red: { label: 'Error', color: '#f44336' }
}

export const AppCard = ({ id, title, badge, description, status = 'green', onClick, isFavorite = false, onToggleFavorite }) => {
  const statusConfig = STATUS_CONFIG[status] || STATUS_CONFIG.green
  const handleClick = () => onClick?.()
  const handleKeyDown = (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && onClick) {
      e.preventDefault()
      onClick()
    }
  }
  const handleStarClick = (e) => {
    e.stopPropagation()
    e.preventDefault()
    onToggleFavorite?.(id)
  }
  const handleStarKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.stopPropagation()
      e.preventDefault()
      onToggleFavorite?.(id)
    }
  }
  return (
    <div
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        height: '100%',
        minWidth: 0,
        position: 'relative'
      }}
    >
    <View
      UNSAFE_style={{
        position: 'relative',
        border: '1px solid var(--card-border)',
        borderRadius: '8px',
        padding: '1.25rem',
        backgroundColor: 'var(--white)',
        cursor: onClick ? 'pointer' : 'default',
        minHeight: '10rem',
        height: '100%'
      }}
    >
      {onToggleFavorite && (
        <button
          type="button"
          onClick={handleStarClick}
          onKeyDown={handleStarKeyDown}
          aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
          style={{
            position: 'absolute',
            top: '0.75rem',
            right: '0.75rem',
            padding: '0.25rem',
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            color: isFavorite ? '#f4b400' : '#9e9e9e',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {isFavorite ? (
            <Star size="S" UNSAFE_style={{ width: 18, height: 18 }} />
          ) : (
            <StarOutline size="S" UNSAFE_style={{ width: 18, height: 18 }} />
          )}
        </button>
      )}
      <View
        UNSAFE_style={{
          display: 'inline-block',
          padding: '0.25rem 0.5rem',
          borderRadius: '4px',
          backgroundColor: statusConfig.color,
          color: 'white',
          fontSize: '0.75rem',
          fontWeight: 600,
          marginBottom: '0.75rem'
        }}
      >
        {badge || statusConfig.label}
      </View>
      <Heading level={3} UNSAFE_style={{ margin: 0, marginBottom: '0.5rem', fontSize: '1.125rem' }}>
        {title}
      </Heading>
      <Text UNSAFE_style={{ color: 'var(--gray-600)', fontSize: '0.875rem', lineHeight: 1.5 }}>
        {description}
      </Text>
    </View>
    </div>
  )
}
